<svelte:options customElement={{ tag: "app-landing", shadow: "none" }} />

<script>
  import { onMount } from "svelte";

  import ToolCard from "./ToolCard.svelte";

  let currentUser = false
  let authorizationsForCurrentUser = false

  onMount(async () => {
    console.log("Landing")
    
    currentUser = await window.api.authentication.getCurrentUser.query();
    authorizationsForCurrentUser = await window.api.authorization.authorizations.query({ appId: 2 });
  });
</script>

<main>

  <header class="navbar navbar-expand-md d-print-none">
    <div class="container-xl">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbar-menu"
        aria-controls="navbar-menu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div
        class="d-none-navbar-horizontal pe-0 pe-md-3"
      >
        <a href="/" aria-label="GamePoint">
          <img src="https://gamepoint.tech/images/common/logos/logo_gpinternational_frontpage.png" 
              width="110" class="navbar-brand-image" alt="GamePoint">
        </a>
      </div>
      <div class="navbar-nav flex-row order-md-last">
        <div class="nav-item dropdown">
          <a
            href="#x"
            class="nav-link d-flex lh-1 text-reset p-0"
            data-bs-toggle="dropdown"
            aria-label="Open user menu"
          >
            <span
              class="avatar avatar-sm"
              style="background-image: url(./static/avatars/002m.jpg)"
            >
              <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"  
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"  
                  stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-menu-2">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M4 6l16 0" />
                <path d="M4 12l16 0" />
                <path d="M4 18l16 0" />
              </svg>
            </span>
          </a>

          <div class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
            <a href="/logout" class="dropdown-item">Logout</a>
          </div>
        </div>
      </div>
    </div>
  </header>
  

  <div class="page">
    <div class="page-header d-print-none pt-4"> 
      <div class="container py-4">
        <div class="row">
          <div class="col-12">
            <h1 class="mb-1">Welcome, {currentUser.username}</h1>
            <p>
              Welcome to the Gamepoint Tooling Portal. Log in once to access all your tools, view your permissions, and manage your settings—all in one place.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <ToolCard title="SWF Uploader" url="https://swf.tools.gamepoint.net" description="Allows you to upload SWF files to the gameserver." />
          </div>
          <div class="col-md-4 col-sm-12">
            <ToolCard title="Data Tools" url="https://data.tools.gamepoint.net" />
          </div>
          <div class="col-md-4 col-sm-12">
            <ToolCard title="Platform Manager" url="https://omega.tools.gamepoint.net/platform/params" isDev={false} description="Allows you to start/stop/restart rooms and launcher ports. And see the status of game related services." />
          </div>
        </div>
      </div>
    </div>
  </div>

</main>